import React from "react"

type CharacterLimit = {
  eyebrowText?: number
  heading?: number
  subHeading?: number
}

interface ContentHeaderProps {
  baseClassName: string
  characterLimit?: CharacterLimit
  eyebrowText?: string
  heading?: string
  subHeading?: string
}

const defaultCharacterLimit = 999999

export const ContentHeader = ({
  baseClassName,
  characterLimit = {
    eyebrowText: defaultCharacterLimit,
    heading: defaultCharacterLimit,
    subHeading: defaultCharacterLimit,
  },
  eyebrowText,
  heading,
  subHeading,
}: ContentHeaderProps) => {
  const { subHeading: subHeadingLimit } = characterLimit

  const outputSubHeading = () => {
    if (!subHeading || !subHeadingLimit) return <></>

    if (subHeading.length <= subHeadingLimit) {
      return <h3>{subHeading}</h3>
    }

    return <p className={`${baseClassName}__intro-paragraph`}>{subHeading}</p>
  }

  return heading ? (
    <div className={`u-container-header ${baseClassName}__heading`}>
      {eyebrowText && <h4 className="eyebrow-text">{eyebrowText}</h4>}
      {heading && <h2>{heading}</h2>}
      {outputSubHeading()}
    </div>
  ) : (
    <></>
  )
}
